import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { updateOccupation } from '../types/api';
import { useUser } from '../context/UserContext';

import '../style/question.css';

import { useLanguage } from "../context/LanguageContext";
import { labelsMap } from "../i18n/languageMap"; 

const OccupationSurveyForm: React.FC = () => {
  const [selectedAnswer, setSelectedAnswer] = useState<string | "">("");
  const navigate = useNavigate();
  //const location = useLocation();
  //const { name, mobile, whatsapp,  email, state, district, city, pinCode } = location.state || {};
 
   const { country, language } = useLanguage();
  const { setUser, user } = useUser();   
  const labels = labelsMap[language] || labelsMap['English'];
 
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAnswer(event.target.value);
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    // Handle form submission logic here
    //setUser({ name, mobile, whatsapp, language, email, country, state, district, city, pinCode });
    setUser({ ...user});
     if (!user?.mobile) {
        console.error("User mobile not available");
        return;
     }
      
    await updateOccupation(user.mobile, selectedAnswer);
    console.log("Selected answer:", selectedAnswer);
    if(selectedAnswer?.trim()) {
       navigate('/videoFormCnt');
    }
  };

  return (
    <div className="div-container">

      <h2>{labels.whatYouLike}</h2>
      
        <form onSubmit={handleSubmit}>
          <div style={{width: '300px'}}>
            <label className="radio-label">
              <input type="radio" value="Business" checked={selectedAnswer === 'Business'} onChange={handleChange} />
              {labels.Business}
            </label>
            <label className="radio-label">
              <input type="radio" value="PrivateJob" checked={selectedAnswer === 'PrivateJob'} onChange={handleChange} />
              {labels.PrivateJob}
            </label>
            <label className="radio-label">
              <input type="radio" value="GovermentJob" checked={selectedAnswer === 'GovermentJob'} onChange={handleChange} />{labels.GovermentJob}
              </label>
            <label className="radio-label">
              <input type="radio" value="Student" checked={selectedAnswer === 'Student'} onChange={handleChange} />{labels.Student}
              </label>
            <label className="radio-label">
              <input type="radio" value="SearchJob" checked={selectedAnswer === 'SearchJob'} onChange={handleChange} />{labels.SearchJob}
              </label>
            <label className="radio-label">
              <input type="radio" value="Retired" checked={selectedAnswer === 'Retired'} onChange={handleChange} />{labels.Retired}
              </label>
            <label className="radio-label">
              <input type="radio" value="Homemaker" checked={selectedAnswer === 'Homemaker'} onChange={handleChange} />{labels.Homemaker}
            </label>
          </div>
          <button type="submit">{labels.submit}</button>
        </form>
    </div>
 );
};

export default OccupationSurveyForm;